<div class="d-flex flex-column h-100">
    <div class="flex-grow-1 overflow-auto">
        <div class="w-100 p-3">
            <div class="solar-loader-icon" *ngIf="showLoader">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            </div>

            @if(isAnyZoneConstraint) {
            <div class="solar-card constraint-zone mb-3">
                <div class="text-st-active">
                    Le bâtiment sélectionné se trouve dans une zone sujette à des contraintes
                    d'installation. Rapprochez-vous de votre mairie afin d'étudier la faisabilité de
                    votre projet solaire.
                </div>
                <div class="container-fluid px-0">
                    <div class="row g-2">
                        <div class="col-sm constraint-type" *ngIf="isConstraintZone.architectural">
                            <st-svg svgName="museum" [height]="22" [width]="22"></st-svg>
                            <div>Zone de protection du patrimoine architectural</div>
                        </div>
                        <div class="col-sm constraint-type" *ngIf="isConstraintZone.nature">
                            <st-svg svgName="forest" [height]="22" [width]="22"></st-svg>
                            <div>Zone de protection de la nature</div>
                        </div>
                        <div class="col-sm constraint-type" *ngIf="isConstraintZone.altitude">
                            <st-svg svgName="mountain" [height]="22" [width]="22"></st-svg>
                            <div>Zone > 800m d'altitude</div>
                        </div>
                        <div class="col-sm constraint-type" *ngIf="isConstraintZone.coastal">
                            <st-svg svgName="wave" [height]="22" [width]="22"></st-svg>
                            <div>Zone côtière</div>
                        </div>
                    </div>
                </div>
            </div>
            } @if(selectedElements.length > 0) {
            <div class="solar-card project-perimeter">
                <h5 class="text-st-primary mb-0">Périmètre de mon projet</h5>

                <div class="selection-resume">
                    <h6>{{ selectedRoofTitle }}</h6>
                    <div class="container-fluid solar-card p-2">
                        <ng-container *ngFor="let element of selectedElements">
                            <div class="row d-flex align-items-center selected-element">
                                <div class="col">
                                    <div class="text-st-primary">{{ element.addressLabel }}</div>
                                    <div class="text-st-muted fs-65">{{ element.parcelLabel }}</div>
                                </div>
                                <div class="col-auto">
                                    <div class="row gx-0">
                                        <div class="col d-flex align-items-center">
                                            <stButton
                                                btnClass="btn-st-inverted-primary"
                                                (onClick)="findElementOnMap(element.id)"
                                                title="Localiser la toiture"
                                                iconLeft="bi bi-geo-alt-fill fs-4"
                                            ></stButton>
                                        </div>
                                        <div class="col text-center">
                                            <stButton
                                                class="remove-button"
                                                btnClass="btn-st-inverted-primary"
                                                (onClick)="removeElement(element.id)"
                                                title="Retirer des toitures sélectionnées"
                                                iconSvgLeft="cross"
                                                [iconSvgHeight]="30"
                                                [iconSvgWidth]="30"
                                            >
                                                ></stButton
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <div class="solar-loader-icon" *ngIf="solarService.selectionInfo.showLoader">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                </div>

                @if(!solarService.selectionInfo.showLoader) {
                <div class="selection-info">
                    <div>
                        <span> {{ solarService.selectionInfo.myRoof }} </span>
                        <span class="text-st-active">
                            {{ solarService.selectionInfo.totalModuleArea }}&nbsp;m²
                        </span>
                        <span>de panneaux sur</span>
                        <span class="text-st-active">
                            {{ solarService.selectionInfo.totalGrossRoofArea }}&nbsp;m²
                        </span>
                        <span>
                            {{ solarService.selectionInfo.direction }} {{
                            solarService.selectionInfo.tilt }}
                        </span>
                    </div>

                    <div *ngIf="distributions.length">
                        Répartition du potentiel solaire des toitures sélectionnées par m² de
                        surface :
                    </div>
                </div>

                <div class="distribution" *ngIf="distributions.length">
                    <div class="container distribution">
                        @for (item of distributions; track item.label) {
                        <div class="row" [style.opacity]="item.opacity">
                            <div class="col label">{{ item.label }}</div>
                            <div class="col">
                                <div class="pseudo-bar-chart">
                                    <div
                                        [style.width]="item.width"
                                        [style.background-color]="item.color"
                                    ></div>
                                </div>
                            </div>
                            <div class="col text-st-active">{{ item.value }} m<sup>2</sup></div>
                        </div>
                        }
                    </div>
                </div>

                <!-- <stButton
                    btnLabel="Personnaliser la surface disponible"
                    btnClass="btn-st-default w-100"
                    (click)="goToStage('parametersStage')"
                    *ngIf="!solarService.results.length"
                >
                </stButton> -->
                }
            </div>
            }
        </div>
    </div>

    <div class="footer border-top" *ngIf="selectedElements.length && !showLoader">
        <div class="container-fluid text-center py-3">
            <div class="row">
                <div class="col-5" *ngIf="solarService.results.length > 0">
                    <stButton
                        btnClass="btn-st-default w-100 h-100"
                        btnLabel="Retour"
                        (onClick)="goToStage('resultsStage')"
                    >
                    </stButton>
                </div>
                <div
                    [ngClass]="{'col-7': solarService.results.length > 0, 'col-12': solarService.results.length == 0}"
                >
                    <stButton
                        class="btn-st-lg"
                        btnClass="btn-st-primary w-100"
                        btnLabel="Démarrer ma simulation de projet solaire"
                        (onClick)="startSimulation()"
                        [isDisabled]="selectedElements.length == 0"
                    >
                    </stButton>
                </div>
            </div>
        </div>
    </div>
</div>
